// extracted by mini-css-extract-plugin
export var articles = "style-module--articles--7d728";
export var body = "style-module--body--045c8";
export var content = "style-module--content--06f2a";
export var head = "style-module--head--bbccf";
export var image = "style-module--image--7e6bd";
export var title = "style-module--title--9f675";
export var titleContainer = "style-module--titleContainer--71e28";
export var topic = "style-module--topic--7b4bb";